import { useEffect, useState } from "react";
import "./Tasks.css";
import { Button, Table } from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import { ITask } from "../../models/task";
import { Loading } from "../../components/Loading/Loading";
import { getTasks } from "../../services/calculationsService";
import { TasksRow } from "./TasksRow";

export const Tasks = () => {
    const navigate = useNavigate();
    const params: { calculationId?: string } = useParams();
    const [tasks, setTasks] = useState<ITask[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getTasks(params.calculationId ?? "").then(res => {
            const newTasks = res;
            newTasks.forEach(task => {
                task.failedSubtasks = task.subtasks.filter(
                    x => x.finished !== "0001-01-01T00:00:00" && !x.isComplete
                ).length;
                task.successSubtasks = task.subtasks.filter(
                    x => x.finished !== "0001-01-01T00:00:00" && x.isComplete
                ).length;
                task.runningSubtasks = task.subtasks.filter(x => x.isRunning).length;

                const parts = task.additionalData?.split(";")!;
                if (parts) {
                    task.user = parts[0];
                    task.calculationDate = parts[1].replace(" ", "T");
                    task.calculationType = parseInt(parts[2].split("=")[1]);
                }
            });
            setTasks(res);
            setLoading(false);
        });
    }, [params.calculationId]);

    return (
        <div id="tasks-page-container" className="tasks-page-container">
            <div id="tasks-page-title-div" className="tasks-page-title tsc-blue">
                <h1 id="tasks-page-title">Calculation status</h1>
                <Button
                    id="button-tasks-a"
                    primary
                    content="Back to list of calculations"
                    onClick={() => navigate("/Study")}
                />
            </div>
            <div id="tasks-page-content" className="tasks-page-content">
                {loading ? (
                    <Loading />
                ) : !loading && tasks.length > 0 ? (
                    <Table id="table-tasks-a" singleLine striped basic="very" unstackable textAlign="center">
                        <Table.Header id="table-header-tasks-a">
                            <Table.Row id="table-row-tasks-a">
                                <Table.HeaderCell id="table-headerCell-tasks-name">Name</Table.HeaderCell>
                                <Table.HeaderCell id="table-headerCell-tasks-added">Added</Table.HeaderCell>
                                <Table.HeaderCell id="table-headerCell-tasks-subtasks">
                                    Timestamps (Failed/Success/Running/Total)
                                </Table.HeaderCell>
                                <Table.HeaderCell id="table-headerCell-tasks-completed">Completed?</Table.HeaderCell>
                                <Table.HeaderCell id="table-headerCell-tasks-a"></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body id="table-body-tasks">
                            {tasks.map(task => (
                                <TasksRow key={task.id + task.stage} task={task} />
                            ))}
                        </Table.Body>
                    </Table>
                ) : (
                    <h2 id="tasks-null">No tasks found for this calculation</h2>
                )}
            </div>
        </div>
    );
};
